import { z } from 'zod';
import { CURRENCIES } from '../money/money';
import { toContactPhone, toKenyanMobile } from '../phone/kenyan-mobile';

export const idSchema = z.string().min(1).max(64);

export const moneySchema = z.object({
  amountMinor: z.number().int().refine(Number.isSafeInteger, 'Amount out of range'),
  currency: z.enum(CURRENCIES),
});

/** Every driver-app mutation carries one; the server dedupes on it. */
export const idempotencyKeySchema = z.string().uuid();

/** A Kenyan mobile number, typed with or without +254 (0712 345 678, 712345678), read as E.164: +254712345678. */
export const kePhoneSchema = z.string().transform((value, ctx) => {
  const phone = toKenyanMobile(value);
  if (phone) return phone;
  ctx.addIssue({ code: 'custom', message: 'Expected a Kenyan mobile number, like 0712 345 678' });
  return z.NEVER;
});

/** A contact's phone, which may be a landline or abroad: free text, but a Kenyan mobile is stored in E.164 (`toContactPhone`). */
export const contactPhoneSchema = z.string().trim().min(1).max(32).transform(toContactPhone);

/** KRA PIN: one letter, nine digits, one letter (e.g. A123456789Z). Uppercased so a stored PIN is always comparable. */
export const kraPinSchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z]\d{9}[A-Z]$/, 'Expected a KRA PIN: one letter, nine digits, one letter');
